import React from 'react';
import { SET_ALERT, SET_VIEW } from 'constants/actionTypes';
import { LS, actionErrors, actionSuccesses } from 'constants/localization';

export const clearView = () => dispatch => {
  dispatch({ type: SET_VIEW, view: { view: null } });
};

export const setView = view => dispatch => {
  dispatch({ type: SET_VIEW, view });
};

export const setAlert = alert => dispatch => {
  dispatch({ type: SET_ALERT, alert: { ...alert, showing: true } });
};

export const hideAlert = () => dispatch => {
  dispatch({ type: SET_ALERT, alert: { showing: false } });
};

export const actionSuccess = key => dispatch => {
  dispatch(setAlert({
    contents: (
      <div>
        <span>{actionSuccesses[LS.getLanguage()][key]}  </span>
        <img src='images/icons/tick.png' alt='OK' title='OK' />
      </div>
    ),
    timeOut: 3000
  }));
};

export const actionError = error => dispatch => {
  // Ignore aborted fetches (navigating page while fetch still in progress)
  if (error.name == 'AbortError') {
    return;
  }
  // Expected errors have message as key to localized error msg
  let msg = actionErrors[LS.getLanguage()][error.message];

  if (!msg) {
    msg = error.message;
  }

  let msgContent = msg;
  if (error.desc) {
    msgContent = msgContent + ' ' + error.desc;
  }
  let errorVariant = 'danger';
  if (error.variant) {
    errorVariant = error.variant;
  }
  
  dispatch(setAlert({ contents: msgContent, variant: errorVariant }));
};
